import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { 
  moveProcedureUpAction, 
  moveProcedureDownAction 
} from '../../../../../../services/EncounterService/slice';

/**
 * Hook for handling service grid actions (move up/down)
 */
export function useServiceActions() {
  const dispatch = useAppDispatch();

  const handleMoveUp = useCallback(
    (procedureId: string, event: React.MouseEvent) => {
      event.stopPropagation(); // Prevent row selection
      dispatch(moveProcedureUpAction(procedureId));
    },
    [dispatch]
  );

  const handleMoveDown = useCallback(
    (procedureId: string, event: React.MouseEvent) => {
      event.stopPropagation(); // Prevent row selection
      dispatch(moveProcedureDownAction(procedureId));
    },
    [dispatch]
  );

  return { handleMoveUp, handleMoveDown };
}
